import React from "react";
import { getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const CheckIn = React.lazy(() => import("@mediaspace/features/event-check-in"));

export const render = getStandaloneComponentRenderer(CheckIn);
